import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import { basePath } from "./constants";
import Home from "./pages/Home";
import Brand from "./pages/Brand";
import Press from "./pages/Press";
import News from "./pages/News";
import Deals from "./pages/Deals";
import Shop from "./pages/Shop";
import Contact from "./pages/Contact";
import Bistro from "./pages/Bistro";
import Spa from "./pages/Spa";

import LocalHome from "./pages/LocalHome";
import AllRooms from "./pages/AllRooms";
import RoomsOverview from "./pages/RoomsOverview";
import Facilities from "./pages/Facilities";
import Accessibility from "./pages/Accessibility";
import Events from "./pages/Events";
import Faq from "./pages/Faq";

// Dynamic redirect component
const RedirectToRestType = () => {
  const { country, type } = useParams();
  return <Navigate to={`/${country}/rest/${type}`} replace />;
};

export default function App() {
  return (
    <BrowserRouter basename={basePath}>
      <Routes>
        {/* top‐level pages */}
        <Route path="/" element={<Home />} />
        <Route path="/concept" element={<Brand />} />
        <Route path="/press" element={<Press />} />
        <Route path="/discover" element={<News />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/opeumbistro" element={<Bistro />} />
        <Route path="/thecanopyspa" element={<Spa />} />

        {/* country‐scoped pages */}
        <Route path=":country">
          {/* /:country */}
          <Route index element={<LocalHome />} />

          {/* /:country/rest  (rooms overview) */}
          <Route path="rest" element={<AllRooms />} />

          {/* legacy /:country/rooms → redirect to /rest */}
          <Route path="rooms" element={<Navigate to="rest" replace />} />

          {/* /:country/rest/:type */}
          <Route path="rest/:type" element={<RoomsOverview />} />

          {/* legacy /:country/rooms/:type → redirect */}
          <Route path="rooms/:type" element={<RedirectToRestType />} />

          {/* /:country/experience */}
          <Route path="experience" element={<Facilities />} />

          {/* legacy /facilities → redirect */}
          <Route
            path="facilities"
            element={<Navigate to="../experience" replace />}
          />

          {/* /:country/location */}
          <Route path="location" element={<Accessibility />} />

          {/* /:country/events */}
          <Route path="events" element={<Events />} />

          {/* /:country/faq */}
          <Route path="faq" element={<Faq />} />
        </Route>

        {/* catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
